import React from 'react';
import { Form } from 'antd';
import { Checkbox, FormControlLabel, Grid, TextField, Snackbar, InputLabel, Select, MenuItem } from '@material-ui/core';
import { LayoutTypesLookup } from "../../../layoutTypes/components/lookupForm";
import MySnackbarContentWrapper from "../../../../components/SnackBar";

class SettingsForm extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    layoutTypeId : this.props.layoutTypeId,
    trigger: this.props.trigger,
    condition: this.props.condition,
    infiniteScroll: this.props.infiniteScroll,
    snackOpen : false,
    snackType: "info",
    snackMessage: "Action executing..."
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  setStateValues = (open,type,message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ snackOpen: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.query_f({ variables: { 
          id: this.props.id, 
          url: values.url, 
          publisherId: this.props.publisherId, 
          layoutType: this.state.layoutTypeId,
          trigger: this.state.trigger,
          condition: this.state.condition,
          infiniteScroll: this.state.infiniteScroll ? Boolean(this.state.infiniteScroll) : false } })
        .then(result =>{
          this.setStateValues(true,"success","Action executed with success!");
          this.props.form.resetFields();
          if(this.props.onCancel){
            this.props.onCancel();
          }
          localStorage.setItem('adireto-drawer-open', false);
        }, error=>{
          this.setStateValues(true,"error","Action executed with error!");          
        });
      }
      else{
        this.setStateValues(true,"error","Form validation failed!");  
      }
    });
  }

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  myChange = (value) => { 
    this.setState({ layoutTypeId: value });
  };

  handleChangeTrigger = (value) => { 
    if(value && value.target && value.target.value){
    this.setState({ trigger: value.target.value });
    }
  };

  handleChangeCondition = (value) => { 
    if(value && value.target && value.target.value){
      this.setState({ condition: value.target.value });
      }
  };

  handleChangeCheckBox = (event) => {
    this.setState({ infiniteScroll: event.target.checked });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const myForm = this.props;
    const layoutTypeId = { layoutTypeId: this.state.layoutTypeId };

    return (
      <form id="myForm" onSubmit={this.handleSubmit}>
      <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }} open={this.state.snackOpen} autoHideDuration={6000} onClose={this.handleClose}>
        <MySnackbarContentWrapper onClose={this.handleClose} variant={this.state.snackType} message={this.state.snackMessage}/>
      </Snackbar>
        <Grid container spacing={0}>
        <Grid item xs={12}>
          {getFieldDecorator('url', {
            initialValue: (this.props.url || ''),
            rules: [{ required: true, message: 'Please input url!', whitespace: true }],
          })(
            <TextField
                  id="url"
                  label="url"
                  color="primary"
                  fullWidth
                  style={{ marginTop : 13 }}
                  InputLabelProps={{
                    shrink : true,
                  }}
                  placeholder="url"
                />
          )}
        </Grid>
        <Grid item xs={12}>
        <LayoutTypesLookup form={myForm} layoutTypeId={layoutTypeId} onChange={this.myChange}/>
        </Grid>

          <Grid item xs={12}>
          <InputLabel style={{ fontSize : 12, marginTop: 15 }}>Trigger</InputLabel>
              <Select fullWidth id="trigger"
                labelId="select-settings-trigger"
                onChange={this.handleChangeTrigger} value={this.state.trigger}
              >
                <MenuItem value="AllPages" key="AllPages">All Pages</MenuItem>
                <MenuItem value="SpecificPages" key="SpecificPages">Specific Pages</MenuItem>
              </Select>
          </Grid>
          
          <Grid item xs={12}>
          <InputLabel style={{ fontSize : 12, marginTop: 15 }}>Condition</InputLabel>
              <Select fullWidth id="condition"
                labelId="select-settings-condition"
                onChange={this.handleChangeCondition} value={this.state.condition}
              >
                <MenuItem value="SecondPages" key="SecondPages">SecondPages</MenuItem>
                <MenuItem value="Contains" key="Contains">Contains</MenuItem>
                <MenuItem value="Equals" key="Equals">Equals</MenuItem>
              </Select>
          </Grid>
          <Grid item xs={4}>
          {getFieldDecorator('infiniteScroll', { initialValue: (this.props.infiniteScroll || ''), rules: [{ required: false }],})(
            <>
              <FormControlLabel
                control={
                  <Checkbox id="infiniteScroll"
                    checked={this.state.infiniteScroll}
                    value={this.state.infiniteScroll}
                    onChange = {this.handleChangeCheckBox}
                    inputProps={{
                      'aria-label': 'primary checkbox',
                    }}
                  />
                }
                style={{marginTop : 10}}
                label="Infinite Scroll" />
              </>
          )}
        </Grid>   
        </Grid>
        </form>
    );
  }
}

const SettingForm = Form.create()(SettingsForm);

export default SettingForm